import { selector } from 'recoil';
import { methodNameEnum } from './makePHPRequest';
import { businessNumberReporting } from './businessNumberReporting';
import {
  endpointEnum,
  makeAPIRequest,
} from '../../services/rest/makeAPIRequest';
import { user } from '../atoms/user';

export const inboundSummary = selector({
  key: 'inboundSummary',
  get: ({ get }) => {
    try {
      // const BusinessNumbers = get(
      //   makePHPRequest({ methodName: methodNameEnum.GET_BUSINESS_NUMBERS })
      // );
      const userAtom = get(user);
      const data = {
        call: methodNameEnum.GET_BUSINESS_NUMBERS,
        apikey: userAtom?.apikey,
        businessid: userAtom?.businessid,
      };
      const BusinessNumbers = get(
        makeAPIRequest({
          endpoint: endpointEnum.GET_BUSINESS_NUMBERS,
          payloadJsonString: JSON.stringify(data),
        })
      );
      const numReport = get(businessNumberReporting);
      const stats =
        JSON.parse(JSON.stringify(numReport))?.data?.stats?.numbers ?? {};
      // find businesss number that are in our business reports
      // cycle through business numbers and create new report with augmented
      // name, allavgduration, incom/ingmissed_pct
      const result = BusinessNumbers?.response?.data?.result
        ?.filter((businessNumber) => stats[`+${businessNumber.DID}`])
        .map((businessNumber) => {
          // console.log('testing', businessNumber);
          const currentStat = stats[`+${businessNumber.DID}`];
          return {
            name: businessNumber.numberName,
            destinationName:
              businessNumber.type + ': ' + businessNumber.destinationName,
            type: businessNumber.type,
            destinationid: businessNumber.destinationid,
            numberid: businessNumber.Numberid,
            number: currentStat.number,
            allcalls: currentStat.total || 0,
            allmissed: currentStat.allmissed || 0,
            allanswered: currentStat.allanswered || 0,
            allduration: currentStat.allduration || 0,
            allconnections: currentStat.allconnections || 0,
            allavgduration: ((currentStat.alldurationavg || 0) / 60).toFixed(2),
            allincoming: currentStat.allincoming || 0,
            incomingmissed: currentStat.incomingmissed || 0,
            incomingmissed_pct:
              (
                (currentStat.incomingmissed / currentStat.allincoming || 0) *
                100
              )
                .toFixed(1)
                .toString() + '%',
            incominganswered: currentStat.incominganswered || 0,
            duration: currentStat.duration || 0,
            incomingconnection: currentStat.incomingconnection || 0,
          };
        });

      return result;
    } catch (error) {
      throw error;
    }
  },
});
